import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';

import * as fromApp from '../../store/app.reducers';
import * as fromPayment from '../store/payment.reducers';
import * as PaymentAction from '../store/payment.actions';
import * as fromUser from '../../user/store/user.reducers';
import {PaymentService} from '../payment.service';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss'],
    standalone: false
})
export class PaymentSuccessComponent implements OnInit, OnDestroy {

  id: number;
  routerTimeout;
  routeSubscription: Subscription;
  paymentState: Observable<fromPayment.State>;
  userSubscription: Subscription;
  paymentSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<fromApp.AppState>,
    private paymentService: PaymentService
  ) { }

  ngOnInit() {
    this.userSubscription = this.store.select('user').subscribe(
      (userState: fromUser.State) => {
        // this.paymentService.redirectAfterPayment(userState);
      }
    );

    this.paymentState = this.store.select('payment');
    this.paymentSubscription = this.store.select('payment').subscribe(
      (state: fromPayment.State) => {
        if (state.paymentDetail !== null) {
          this.store.dispatch(new
            PaymentAction.TrackFacebookConversion(state.paymentDetail.id)
          );

          (<any>window).fbq('track', 'Purchase', {currency: 'USD', value: state.paymentDetail.amount});
          if (state.paymentDetail.user.type === 1) {
            // Instagrammer
            (<any>window).gtag('event', 'conversion', {
              'send_to': 'AW-652188131/0JpBCNjj1MwBEOOz_rYC',
              'value': state.paymentDetail.amount,
              'currency': 'USD',
              'transaction_id': state.paymentDetail.id
            });
          } else if (state.paymentDetail.user.type === 2) {
            // Marketer
            (<any>window).gtag('event', 'conversion', {
              'send_to': 'AW-652188131/7OM8CPiQxcwBEOOz_rYC',
              'value': state.paymentDetail.amount,
              'currency': 'USD',
              'transaction_id': state.paymentDetail.id
            });
          }
        }
      }
    );
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        this.id = +params.id;
        if (this.id !== undefined) {
          this.store.dispatch(
            new PaymentAction.GetPaymentDetails(this.id)
          );
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.routerTimeout !== undefined) {
      clearTimeout(this.routerTimeout);
    }
    this.routeSubscription.unsubscribe();
    this.paymentSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }

}
